module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-admin"
  }, [_c('div', {
    staticClass: "admin-header"
  }, [_c('h1', [_vm._v("Painel de Chat - MASTER")]), _vm._v(" "), _c('div', {
    staticClass: "admin-stats"
  }, [_c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.totalRooms))]), _vm._v(" "), _c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Conversas")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.totalMessages))]), _vm._v(" "), _c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Mensagens")])])])]), _vm._v(" "), _c('div', {
    staticClass: "admin-body"
  }, [_c('div', {
    staticClass: "rooms-panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h2', [_vm._v("Conversas")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "search-input",
    attrs: {
      "placeholder": "Buscar..."
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }, _vm.searchRooms]
    }
  })]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._v("Carregando...")]) : _c('div', {
    staticClass: "rooms-list"
  }, [_vm._l((_vm.rooms), function(room) {
    return _c('div', {
      key: room.id,
      staticClass: "room-card",
      class: {
        active: _vm.selectedRoom && _vm.selectedRoom.id === room.id
      },
      on: {
        "click": function($event) {
          return _vm.selectRoom(room)
        }
      }
    }, [_c('div', {
      staticClass: "room-avatar"
    }, [_vm._v(_vm._s(room.name[0]))]), _vm._v(" "), _c('div', {
      staticClass: "room-info"
    }, [_c('div', {
      staticClass: "room-name"
    }, [_vm._v(_vm._s(room.name))]), _vm._v(" "), _c('div', {
      staticClass: "room-users"
    }, [_vm._v("\n              " + _vm._s(room.users.map(function(u) {
      return u.nome
    }).join(', ')) + "\n            ")])])])
  }), _vm._v(" "), (_vm.rooms.length === 0) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("Nenhuma conversa")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "messages-panel"
  }, [(!_vm.selectedRoom) ? _c('div', {
    staticClass: "empty-state"
  }, [_c('p', [_vm._v("Selecione uma conversa")])]) : _c('div', {
    staticClass: "messages-view"
  }, [_c('div', {
    staticClass: "messages-header"
  }, [_c('button', {
    staticClass: "back-btn",
    on: {
      "click": function($event) {
        _vm.selectedRoom = null
      }
    }
  }, [_vm._v("←")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.selectedRoom.name))]), _vm._v(" "), _c('button', {
    staticClass: "export-btn",
    on: {
      "click": _vm.exportMessages
    }
  }, [_vm._v("Exportar")])]), _vm._v(" "), _c('div', {
    ref: "messagesContainer",
    staticClass: "messages-container"
  }, [(_vm.loadingMessages) ? _c('div', {
    staticClass: "loading"
  }, [_vm._v("Carregando...")]) : _c('div', [_vm._l((_vm.messages), function(msg) {
    return _c('div', {
      key: msg.id,
      staticClass: "message-item"
    }, [_c('div', {
      staticClass: "message-header"
    }, [_c('div', {
      staticClass: "sender-avatar"
    }, [_vm._v(_vm._s(msg.sender.nome[0]))]), _vm._v(" "), _c('div', {
      staticClass: "sender-info"
    }, [_c('strong', [_vm._v(_vm._s(msg.sender.nome))]), _vm._v(" "), _c('span', {
      staticClass: "message-time"
    }, [_vm._v(_vm._s(_vm.formatDateTime(msg.timestamp)))])])]), _vm._v(" "), _c('div', {
      staticClass: "message-content"
    }, [_vm._v(_vm._s(msg.content))])])
  }), _vm._v(" "), (_vm.messages.length === 0) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("Nenhuma mensagem")]) : _vm._e()], 2)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24257fba","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/chat/components/ChatMasterPage.vue
// module id = 1740
// module chunks = 18